import React from 'react';

import purse_banner from '../../images/events/PurseBingoPoster.png';

class PurseBingo extends React.Component {
  render() {
    return (
      <>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <h1>Purse Bingo for Charity</h1>
        <h2>Friday, January 30, 2026</h2>
        <a href="https://ticketscandy.com/e/kofc-council-1056-purse-bingo-for-charity-2026-10825">
          <h2>Purchase Tickets for the Event</h2>
        </a>
        <a href="https://ticketscandy.com/e/kofc-council-1056-purse-bingo-for-charity-2026-10825">
          <img
            src={purse_banner}
            className="text-center responsive-img"
            alt="Purse Bingo"
            style={{ maxWidth: '100%', height: 'auto', display: 'block', margin: '0 auto' }}
          />
        </a>
      </div>
      </>
    );
  }
}

export default PurseBingo;